import React from 'react';
import { z } from 'zod';
import { ThreadUpsertContainerProps } from './integrationUpsertProps';
import { IntegrationContainerBaseConfig } from '../../../base';
import { ThreadNewContainerProps } from '../new/integrationNewProps';
import { ThreadDetailContainerProps } from '../detail/integrationDetailProps';
import { ThreadUpsertController, ThreadUpsertLoader } from './integrationUpsertInterface';
import { assertNever } from '@varos/util-typescript';

export function createThreadUpsertContainer(
    config: IntegrationContainerBaseConfig & {
        Container: {
            New: React.FC<ThreadNewContainerProps>;
            Detail: React.FC<ThreadDetailContainerProps>;
        };
    },
    loader: ThreadUpsertLoader,
    controller: ThreadUpsertController
): React.FC<ThreadUpsertContainerProps> {
    const {
        context: { useContext },
        Container: { New: NewContainer, Detail: DetailContainer },
    } = config;

    return ({ ...containerProps }) => {
        const context = useContext();
        const data = loader.useLoad(context, {
            integration: containerProps.integration,
        });
        const props = controller.useProps(context, data, containerProps);
        if (props.view.kind === 'new') {
            return <NewContainer {...props.view} />;
        }
        if (props.view.kind === 'detail') {
            return <DetailContainer {...props.view} />;
        }
        assertNever(props.view);
    };
}
